/* eslint-disable max-len */
import { Component,ViewChild} from '@angular/core';
//import { NavController, DateTime } from 'ionic-angular';
import { IonDatetime } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
//import { Content } from 'ionic-angular';
import { IonSlides } from '@ionic/angular';
import * as readings from '../../assets/tarot.json';

//Using month number as key (1 indexed), 'end' is the day
const horoscope = {
  1 : {end : 20, sign : 'Capricornio'},
  2 : {end : 19, sign : 'Acuario'},
  3 : {end : 20, sign : 'Piscis'},
  4 : {end : 20, sign : 'Aries'},
  5 : {end : 21, sign : 'Tauro'},
  6 : {end : 21, sign : 'Géminis'},
  7 : {end : 22, sign : 'Cáncer'},
  8 : {end : 23, sign : 'Leo'},
  9 : {end : 23, sign : 'Virgo'},
  10 : {end : 23, sign : 'Libra'},
  11 : {end : 22, sign : 'Escorpión'},
  12 : {end : 21, sign : 'Sagitario'},
};

class MyCard{
public id: number;
public url: string;
public spin: number;
constructor(page: HomePage,myId: number,myUrl: string, mySpin: number) {
  this.id = myId;
  this.url = myUrl;
  this.spin = mySpin;
  page.setCardUrl(myUrl);
}
}

class TarotUser{
id: number;
name: string;
readings: number;
lastReading: string;
credits: number; // gemas
topics: string[];
birthday: string;
country: string;
city: string;
gender: string;
sign: string;
constructor(myId: number = 0, myReadings: number = 0, mylastReadings: string = '',myCredits: number =0 , myTopics: string[]=[]){
  this.id = myId;
  this.name = '';
  this.readings = myReadings;
  this.lastReading = mylastReadings;
  this.credits = myCredits;
  this.topics = myTopics;
  this.birthday = '';
  this.country = '';
  this.city = '';
  this.gender = '';
  this.sign ='';
}

}

const tiradas = {
  cAmor: 'amor',
  cTrabajo: 'trabajo',
  cLuz: 'seres de luz',
  cGen: 'general'
};

const convertDate = (datestr) => {
  //Checking if string is in correct format
  if (datestr.includes('/')) {return;};


  //const meses = monthstr.length>0?monthstr.split(','):['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  const dstr = datestr.split('T')[0].split('-');
  //console.debug('meses  : ', meses);
  if(dstr.length !== 3) {

    console.error('Error in string date. Expected format: \'DD MMM YYYY\'.');
    console.error('Got : ',dstr);
    return '';
  }
  console.log('Date before conversion : ',dstr);
  const dateWithFormat = dstr[2] + '/' + dstr[1] + '/' + dstr[0];
  console.log('Formatted date : ', dateWithFormat);
  return dateWithFormat;
};

const getHosorscopeSign = (datestr,splitChar = '/') => {
  //Expects d/m/Y where month is '1' indexed
  if (datestr === '') {
    return '';
  }
  const dstr = datestr.split(splitChar);
  if(dstr.length !== 3) {
    return '';
  }
  const month = parseInt(dstr[1],10);
  const nextMonth = (month+1)>12?1:month+1;
  const day = parseInt(dstr[0],10);
  //console.debug('Hosorscope - month : ',month, ', next month : ',nextMonth, ', day : ',day);
  //console.debug('Hosroscope : ',horoscope[month]);
  const sign = day>horoscope[month].end?horoscope[nextMonth].sign:horoscope[month].sign;
  return sign;
};


@Component({
  selector: 'app-home',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.scss']
})

export class HomePage {
  @ViewChild(IonSlides) slides: IonSlides;
  pause = true;
  public showStart = false; //Whatever you want to initialise it as
  public showCard = false; //Whatever you want to initialise it as
  public showResult = false;
  public showMagic = false;
  public showTopics = false;
  public isLoading = true;
  public userLoggedIn = false;
  public showFeedback = false;
  public showForm = false;
  public updateProfile = false; //Signalizes birthday, sign, country, city and gender should be send to backend
  public finished = false;

  user: TarotUser;
  putReq = ''; //request parameters to be included in put body

  nonce;
  message = '';
  part1 = '';
  part2 = '';
  part3 = '';
  emoji = 'assets/imgs/Annita4.png';
  cartasStr = '';
  urlMazo = '';
  revMsg = '';
  tirada = tiradas.cGen;
  meses = 'Ene,Feb,Mar,Abr,May,Jun,Jul,Ago,Sep,Oct,Nov,Dic';



  // Add an alement to the array below in order to add a new pahse of the lecture
  phases: string[] = [];
  iter = this.phases[Symbol.iterator]();
  myCards: MyCard[] = [];

  cardUrls = [];
  disableButton: boolean[] = [false,false,false];
  submitEnabled = false;
  topics =[tiradas.cAmor,tiradas.cTrabajo,tiradas.cLuz];
  showCards: boolean [] = [false,false,false];
  results;
  //toast;
  //form: FormsPage;

  constructor(public toast: ToastController) {
    // this.toast = this.Toast.create({
    //   message: msg,
    //   duration: 5000,
    //   //showCloseButton: false,
    //   //closeButtonText: "OK",
    //   cssClass: "my-toast",
    //   position: "middle"
    //   });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.nonce = urlParams.get('nonce');
    this.log('Nonce: ',this.nonce);
    this.user = new TarotUser();
    //this.form = new FormsPage();
    this.isUserLoogedIn();
  }

  log(msg?: any, ...optionalParams: any[]) {
    console.log(msg,optionalParams);
  }

  public updateUser(result) {
    const jsonUsr = JSON.parse(result);
    this.userLoggedIn = jsonUsr.status;
    this.user.id = jsonUsr.id;
    this.user.name = jsonUsr.name;
    this.user.readings = jsonUsr.readings;
    this.user.credits = jsonUsr.gemas;
    this.user.topics = jsonUsr.temas;
    this.user.birthday = jsonUsr.birthday;
    this.user.country = jsonUsr.country;
    this.user.city = jsonUsr.city;
    this.user.gender = jsonUsr.gender;
    this.user.sign = jsonUsr.sign;
  }

  async scrollToElement(element,wait=80) {
    // To do: remove getElementById()
    await this.sleep(wait);
    const myEl = document.getElementById(element);
    if (myEl != null) {
      myEl.scrollIntoView({behavior: 'smooth'});
    }
  }

  isUserLoogedIn(): boolean {
    if(this.nonce === 'AUGL701022') {
      this.userLoggedIn = true;
      this.log('User logged in debug mode #######');
      this.user.name = 'Debug User';
      this.user.readings = 100;
      this.user.credits = 100;
      this.isLoading = false;
      this.initReading();
      this.introReading();
      return true;
    }
    const res = new XMLHttpRequest();
    const theUrl = 'https://www.anna.azuara.net/wp-json/agnesi/v1/readings?_wpnonce='+this.nonce;
    res.open('GET',theUrl, true); // asynchronous request
    //res.setRequestHeader("Access-Control-Allow-Origin", "http://localhost:8100");
    res.withCredentials = true; // required to send the cookie within the request
    //console.log('> Request: GET ',theUrl);
    res.send (null);
    const self = this;
    // Check this post for clariication about 'this' ussage:
    // https://stackoverflow.com/questions/20279484/how-to-access-the-correct-this-inside-a-callback
    res.onload = function() {
      const result = this.responseText;
      self.updateUser(result);
      self.log('> Response: ',result);
      self.log('id : ',self.user.id);
      self.log('status : ', self.userLoggedIn);

      if(self.userLoggedIn) {
        //this.getUserReadings();
        self.initReading();
        self.introReading();
      } else {
        self.showStart = false;
        self.showTopics = false;
        self.showCard = false;
        self.isLoading = false;
        self.showResult = true;
        self.cartasStr = 'Para usar el tarot tienes que ingresar al Mundo Mágico';
        self.scrollToElement('lectura1');
      }
    };
    return this.userLoggedIn;
  }

  getUserReadings() {
    const res= new XMLHttpRequest();
    const lastReadEndpoint = 'https://www.anna.azuara.net/wp-json/buddypress/v1/xprofile/521/data/' + this.user.id + '?_wpnonce='+ this.nonce;
    res.open('GET',lastReadEndpoint, true); // asynchronous request
    res.withCredentials = true; // required to send the cookie within the request
    this.log('Request: GET ',lastReadEndpoint);
    res.setRequestHeader('Access-Control-Allow-Origin', '*');
    res.send (null);
    res.onload = () => {
      const result = res.responseText;
      //const localReadings = JSON.parse(result)[0].value.unserialized[0];
      //const lastRead = JSON.parse(result)[0].last_updated;
      //console.debug('-Response- : ', result);
      //console.debug('-Readings- : ', readings, ' last read : ',  lastRead);
    };

    return res;
  }
  onSubmit(event = null) {
    //To do: validate data
    this.user.birthday = convertDate(this.user.birthday);

    if (this.user.birthday === '') {
      this.presentToast('Introduce la fecha de tu nacimiento');
      return;
    }
    this.user.sign = getHosorscopeSign(this.user.birthday);
    this.showForm = false;
    this.updateProfile = true;
    this.introReading();
  }

  ionChange(event = null) {
    this.log('User birthday : ',this.user.birthday);
    if (this.user.birthday !== '') {
      this.submitEnabled = true;
      return;
    }
  }

  introReading(){
    //console.debug('User : ',this.user);
    if (this.user.birthday === '') {
      this.showForm = true;
      this.showMagic = false;
      this.isLoading = false;
      this.submitEnabled = false;
    } else {
      this.isLoading  =false;
      this.showStart = false;
      this.showTopics = true;
      this.showCard = false;
      this.showResult = true;
      this.showMagic = false;
      this.showFeedback = false;
      this.finished = false;
      this.part1 = '';
      this.part2 = '';
      this.part3 = '';
      this.emoji = 'assets/imgs/Annita' + Math.ceil(Math.random() * 4) + '.png';
      if (this.user.sign === '') {
        this.user.sign = getHosorscopeSign(this.user.birthday);
        this.putReq = this.putReq + ',"sign" : "' + this.user.sign + '"';
      }
      if (this.user.readings > 0) {
        if (this.user.credits <= 0) {
          this.cartasStr = 'No tienes más gemas. Para obtener gemas participa en los foros o vuelve mañana.';
          this.showTopics = false;
          this.showFeedback = true;
        } else {
          const suf2 = (this.user.readings>1)?'s.':'.';
          const gen = this.user.gender === 'Hombre'?'o':'a';
          this.cartasStr = 'Querid' + gen + ' ' + this.user.name + ' (' + this.user.sign + ')';
          this.part1 = 'Hoy tienes ' + this.user.readings + ' pregunta' + suf2;
          this.part2 = 'Busca un lugar tranquilo para tu lectura. Por cada tema vas a elegir 3 cartas. Recuerda que las cartas de cabeza tienen un significado diferente.';
          this.part3 = 'Elige un tema:';
          this.disableButton = [false,false,false];
          let i;
          for (i = 0; i < this.user.topics.length; i++) {
            const ti = this.topics.indexOf(this.user.topics[i]);
            if (ti >= 0) {
              this.disableButton[ti] = true;
            }
          }
        }
      } else {
        this.cartasStr = 'Agotaste tus preguntas de hoy. Regresa mañana.';
        this.part1 = '¿Qué te parece esta modalidad de tarot por WebApp?';
        this.showTopics = false;
        // https://www.anna.azuara.net/consulta-con-anna/
        this.showFeedback = true;
      }
      this.scrollToElement('lectura1');
    }
  }

  initReading(){
    this.showStart = false;
    this.showCard = true;
    this.myCards = [];
    this.cartasStr = '';
    this.pause = false;
    this.showResult = false;
    this.showTopics = false;
    this.loadResults();

    switch(this.tirada) {
      case tiradas.cAmor:
        this.phases = this.results.default.fases.amor;
        this.revMsg = this.results.default.verdad.amor;
        break;
      case tiradas.cTrabajo:
        this.phases = this.results.default.fases.trbj;
        this.revMsg = this.results.default.verdad.trbj;
        break;
      case tiradas.cLuz:
        this.phases = this.results.default.fases.luz;
        this.revMsg = this.results.default.verdad.luz;
        break;
      default:
        this.phases =  this.results.default.fases.gen;
        this.revMsg = this.results.default.verdad.gen;
    }
    this.log('Phases: ',this.phases);
    this.log('Revelación: ', this.revMsg);


    // eslint-disable-next-line guard-for-in
    for (const i in this.phases) {
      this.cardUrls[i] = '';
    }
  }
  public setCardUrl(url: string){
    this.cardUrls[this.myCards.length] = url;
  }

  inStack(num: number): boolean {
    for (const i of this.myCards) {
      if (num === i.id) {return true;}
    }
    return false;
  }

  loadResults() {
    this.log('Reading json');

    const stringifiedData = JSON.stringify(readings);

    this.results = JSON.parse(stringifiedData as string);
    this.log('Total registered cards : ',this.results.default.cartas.length);

  }

  getReading(pos,tirada = this.tirada){
    if (pos <0 || pos >= this.myCards.length){
      return '';
    }
    switch(tirada) {
      case tiradas.cAmor:
        return (this.myCards[pos].spin?this.results.default.cartas[this.myCards[pos].id].amor_inv:this.results.default.cartas[this.myCards[pos].id].amor);
      case tiradas.cTrabajo:
        return (this.myCards[pos].spin?this.results.default.cartas[this.myCards[pos].id].trbj_inv:this.results.default.cartas[this.myCards[pos].id].trbj);
      case tiradas.cLuz:
        return (this.myCards[pos].spin?this.results.default.cartas[this.myCards[pos].id].luz_inv:this.results.default.cartas[this.myCards[pos].id].luz);
      default:
        return (this.myCards[pos].spin?this.results.default.cartas[this.myCards[pos].id].inv:this.results.default.cartas[this.myCards[pos].id].read);
    }
  }

  processCards() {
    this.cartasStr = (this.cartasStr=== '')?'Intenta otra vez y concéntrate más':this.cartasStr;
    this.log('Spins :', this.myCards[0].spin,this.myCards[1].spin,this.myCards[2].spin);

    //Show card interpretation depending on the type of question made

    this.part1 = this.getReading(0);
    this.part2 = this.getReading(1);
    this.part3 = this.getReading(2);

    if (this.tirada !== tiradas.cGen){
      if(this.part1 === '') {
        this.part1 = this.getReading(0,tiradas.cGen);
      }
      if(this.part2 === '') {
        this.part2 = this.getReading(1,tiradas.cGen);
      }
      if(this.part3 === '') {
        this.part3 = this.getReading(2,tiradas.cGen);
      }
    }
  }

  async stopResume(el) {

    let card = '';
    if (this.pause) {
      this.urlMazo = 'assets/imgs/TarotInteractivo.gif';
      if(this.phases.length > 0) {
        this.pause = false;
        this.chooseCard();
      }
      else {
        this.urlMazo = '';
        this.finished = true;
        this.message = 'Lectura terminada.';
        this.scrollToElement('btn-start');
        return;
      }
    }
    else {
      let num = -1;
      let used = true;
      do {
        num = Math.floor(Math.random() * 78);
        used = this.inStack(num);
        this.log('Generated card id: ',num, ' is already used?: ',used);
      } while (used);
      const cardIdx = this.myCards.length;
      card = 'assets/imgs/'.concat(this.results.default.cartas[num].pic);
      const cardId = 'carta'.concat(cardIdx.toString());

      this.pause = true;

      this.cartasStr = this.cartasStr.concat(this.results.default.cartas[num].carta);
      const spin = Math.floor(Math.random() * 2);
      this.myCards.push(new MyCard(this,num,card,spin));
      await this.sleep(100);
      const img=document.getElementById(cardId);
      this.log('Card Id : ',cardId, ' spin : ',spin);
      const phase = this.phases.length;
      this.log('Phase : ', phase, ' cardIx : ',cardIdx);
      this.slides.length().then(slds => { console.log('Total slides : ', slds);});
      if (phase === 0) {
        //this.scrollToElement(cardId,70);
        this.urlMazo = '';
        this.message = this.revMsg;
        this.finished = true;
        this.processCards();
        this.slides.slideTo(cardIdx, 200).then(() => {
          this.sleep(200);
          this.slides.startAutoplay();
        });
      } else {
        this.urlMazo = 'assets/imgs/Reverso.jpg';
        this.cartasStr = this.cartasStr.concat(', ');
        this.message = 'Toca la carta inferior para continuar';
        this.slides.slideTo(cardIdx, 200);
      }


      if (spin === 1) {
        img.setAttribute('style','transform:rotate(180deg)');
        this.log('Card style : ', img.style );
      }


    }

  }
  hideMagic() {
    this.showMagic = false;
  }

  sleep = (milliseconds) => new Promise(resolve => setTimeout(resolve, milliseconds));

  async presentToast(msg: string) {
    const toast = await this.toast.create({
      message: msg,
      duration: 5000,
      //showCloseButton: false,
      //closeButtonText: "OK",
      cssClass: 'my-toast',
      position: 'middle'
      });
      toast.present();
    }

    updateBackend(topic) {
      const res = new XMLHttpRequest();
      const theUrl = 'https://www.anna.azuara.net/wp-json/agnesi/v1/readings?_wpnonce='+this.nonce;
      res.open('PUT',theUrl, true); // asynchronous request
      res.withCredentials = true; // required to send the cookie within the request
      //res.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      //res.setRequestHeader("Access-Control-Allow-Origin", "*");
      res.setRequestHeader('Content-Type', 'application/json');

      let body = '{ "tema" : "' + topic + '"';
      if (this.updateProfile === true ){
        body = body + ',"birthday" : "' + this.user.birthday.replace(/\s+/g, ' ').trim() + '"'
        + ',"sign" : "' + this.user.sign + '"'
        + ',"country" : "' + this.user.country + '"'
        + ',"city" : "' + this.user.city + '"'
        + ',"gender" : "' + this.user.gender + '"';

        this.updateProfile = false;
      }
       body = body + this.putReq + ' }';
       //console.debug('Body request : ',body);
      //var body = '"temas=' + topic + '"';
      const self = this;
      res.onload = function() {
        const result = this.responseText;
        //console.debug('PUT Response : ',result);
        self.updateUser(result);
      };
      res.onerror = function() {
        console.error('PUT failed : ',this.responseText);
      };
      res.onprogress = () => {
        //console.debug('PUT request is on pregress..');
      };
      //var body = '';
      this.log('PUT Request body : ',body);
      res.send(body);

    }
    updateBackendFetch(topic){
      const theUrl = 'https://www.anna.azuara.net/wp-json/agnesi/v1/readings?_wpnonce='+this.nonce;
      const body = '{ "tema" : "' + topic + '" }';
      fetch(
        theUrl,
        {
          method : 'PUT',
          //credentials: 'same-origin',
          credentials: 'include',
          headers: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        }
        )
        .then( response => response.json() )
        //.then( json => //console.debug(json) )
        .catch( error => console.error('error:', error) );
    }

    public onButtonClick(i,topic) {
      this.tirada = topic;
      this.log('Tirada topic is: ', this.tirada);
      this.initReading();
      this.disableButton[i] = true;
      if (this.user.name !== 'Debug User') {
        this.updateBackend(topic);
      }
      this.urlMazo = 'assets/imgs/TarotInteractivo.gif';
      this.scrollToElement('mazoCarta',150);
      this.chooseCard();
    }

    chooseCard() {
      const msg = this.phases.pop();
      //this.presentToast(msg);
      this.message = msg;
    }

    async continue() {
      if (!this.showResult) {
        if (this.phases.length === 0) {
          // Do something before delay
          this.showMagic = true;
          await this.scrollToElement('magic',150);
          this.emoji = 'assets/imgs/Annita' + Math.ceil(Math.random() * 4) + '.png';

          await this.sleep(3500);

          // Do something after
          this.showMagic = false;
          this.showStart = true;
          this.showResult = true;
          this.finished = true;
          this.scrollToElement('btn-start',80);
        } else {
          await this.scrollToElement('mazoCarta',150);
        }
      }
    }
}
